<!-- 
  Refactored Yama Page - Now uses the new architecture
  Following SOLID principles while maintaining compatibility with existing yama functionality
-->
<template>
  <!-- Use new YamaPage component for cleaner architecture -->
  <YamaPage 
    :member-line-id="memberLineId"
    :member-name="memberName"
    :group-id="groupId"
  />
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import YamaPage from './YamaPage.vue';

/**
 * Wrapper component to maintain backwards compatibility
 * Delegates to the new refactored YamaPage component
 * Preserves existing WebSocket channel configuration
 */
export default defineComponent({
  name: 'YamaIndex',
  
  components: {
    YamaPage
  },
  
  props: {
    memberLineId: {
      type: String,
      required: true
    },
    memberName: {
      type: String,
      default: ''
    },
    groupId: {
      type: [String, Number],
      required: true
    }
  },
  
  // Preserve existing WebSocket channel configuration
  channels: {
    AnswerRoomsChannel: {
      connected() {
        console.log("Yama WebSocket connected (legacy wrapper).");
        // The YamaPage component handles the actual connection logic
      },
      received(data) {
        // Pass through to YamaPage component
        if (this.$refs.yamaPage) {
          this.$refs.yamaPage.receivedMessage(JSON.parse(data));
        }
      },
      disconnected() {
        console.log("Yama WebSocket disconnected (legacy wrapper)");
      },
      rejected() {
        console.log("Yama WebSocket rejected (legacy wrapper)");
      }
    }
  }
});
</script>

<style lang="scss">
@import "~@/assets/styles/reset";

// Preserve existing global styles
.Yama {
  height: 100%;
  min-width: 375px;
  max-width: 480px;
  overflow: hidden;
  
  > .content {
    min-height: 563px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
}

// Additional styles for improved architecture
.yama-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  
  // Ensure proper stacking context
  position: relative;
  z-index: 1;
}
</style>
